import styled, { css } from 'styled-components';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import { minResolution } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import icBtnArrow1x from 'assets/images/common/@1x/ic_btn_arrow.png';
import icBtnArrow2x from 'assets/images/common/@2x/ic_btn_arrow@2x.png';
import icBtnArrow3x from 'assets/images/common/@3x/ic_btn_arrow@3x.png';
import icBtnArrow2_1x from 'assets/images/common/@1x/ic_btn_arrow2.png';
import icBtnArrow2_2x from 'assets/images/common/@2x/ic_btn_arrow2@2x.png';
import icBtnArrow2_3x from 'assets/images/common/@3x/ic_btn_arrow2@3x.png';
import icBtnArrowLeft1x from 'assets/images/common/@1x/ic_btn_arrow_left.png';
import icBtnArrowLeft2x from 'assets/images/common/@2x/ic_btn_arrow_left@2x.png';
import icBtnArrowLeft3x from 'assets/images/common/@3x/ic_btn_arrow_left@3x.png';
import icBtnPlus1x from 'assets/images/common/@1x/ic_btn_plus.png';
import icBtnPlus2x from 'assets/images/common/@2x/ic_btn_plus@2x.png';
import icBtnPlus3x from 'assets/images/common/@3x/ic_btn_plus@3x.png';
import icBtnMinus1x from 'assets/images/common/@1x/ic_btn_minus.png';
import icBtnMinus2x from 'assets/images/common/@2x/ic_btn_minus@2x.png';
import icBtnMinus3x from 'assets/images/common/@3x/ic_btn_minus@3x.png';
import icBtnEditPC1x from 'assets/images/PC/@1x/ic_btn_edit.png';
import icBtnEditPC2x from 'assets/images/PC/@2x/ic_btn_edit@2x.png';
import icBtnEditSP2x from 'assets/images/SP/@2x/ic_btn_edit@2x.png';
import icBtnEditSP3x from 'assets/images/SP/@3x/ic_btn_edit@3x.png';
import icBtnEditPressPC1x from 'assets/images/PC/@1x/ic_btn_edit_press.png';
import icBtnEditPressPC2x from 'assets/images/PC/@2x/ic_btn_edit_press@2x.png';
import icBtnEditPressSP2x from 'assets/images/SP/@2x/ic_btn_edit_press@2x.png';
import icBtnEditPressSP3x from 'assets/images/SP/@3x/ic_btn_edit_press@3x.png';
import icBtnDeletePC1x from 'assets/images/PC/@1x/ic_btn_delete.png';
import icBtnDeletePC2x from 'assets/images/PC/@2x/ic_btn_delete@2x.png';
import icBtnDeleteSP2x from 'assets/images/SP/@2x/ic_btn_delete@2x.png';
import icBtnDeleteSP3x from 'assets/images/SP/@3x/ic_btn_delete@3x.png';
import icBtnDeletePressPC1x from 'assets/images/PC/@1x/ic_btn_delete_press.png';
import icBtnDeletePressPC2x from 'assets/images/PC/@2x/ic_btn_delete_press@2x.png';
import icBtnDeletePressSP2x from 'assets/images/SP/@2x/ic_btn_delete_press@2x.png';
import icBtnDeletePressSP3x from 'assets/images/SP/@3x/ic_btn_delete_press@3x.png';
import icBtnConfirmPC1x from 'assets/images/PC/@1x/ic_btn_confirmation.png';
import icBtnConfirmPC2x from 'assets/images/PC/@2x/ic_btn_confirmation@2x.png';
import icBtnConfirmSP2x from 'assets/images/SP/@2x/ic_btn_confirmation@2x.png';
import icBtnConfirmSP3x from 'assets/images/SP/@3x/ic_btn_confirmation@3x.png';
import icBtnConfirmPressPC1x from 'assets/images/PC/@1x/ic_btn_confirmation_press.png';
import icBtnConfirmPressPC2x from 'assets/images/PC/@2x/ic_btn_confirmation_press@2x.png';
import icBtnConfirmPressSP2x from 'assets/images/SP/@2x/ic_btn_confirmation_press@2x.png';
import icBtnConfirmPressSP3x from 'assets/images/SP/@3x/ic_btn_confirmation_press@3x.png';
import icBtnClosePC1x from 'assets/images/PC/@1x/ic_btn_close.png';
import icBtnClosePC2x from 'assets/images/PC/@2x/ic_btn_close@2x.png';
import icBtnCloseSP2x from 'assets/images/SP/@2x/ic_btn_close@2x.png';
import icBtnCloseSP3x from 'assets/images/SP/@3x/ic_btn_close@3x.png';
import icBtnClosePressPC1x from 'assets/images/PC/@1x/ic_btn_close_press.png';
import icBtnClosePressPC2x from 'assets/images/PC/@2x/ic_btn_close_press@2x.png';
import icBtnClosePressSP2x from 'assets/images/SP/@2x/ic_btn_close_press@2x.png';
import icBtnClosePressSP3x from 'assets/images/SP/@3x/ic_btn_close_press@3x.png';

const buttonStyleA = css`
  background-color: ${Colors.orange1};
  background-image: url('${icBtnArrow1x}');
  background-size: 24px;
  background-position: calc(100% - 8px) 50%;
  color: ${Colors.white1};

  &:active {
    background-color: ${Colors.orange3};
    cursor: pointer;
  }

  &:disabled {
    color: ${Colors.gray1} !important;
    background-color: ${Colors.gray3} !important;
    opacity: 1;
  }

  ${CustomMedia.greaterThan('umedium')`
    ${FontStyles.text8};

    width: 308px;
    height: 56px;

    &:hover {
      background-color: ${Colors.orange3};
    }
  `}

  ${CustomMedia.lessThan('medium')`
    ${FontStyles.text6};

    width: 100%;
    height: 48px;
    margin-right: 16px;
    margin-left: 16px;
  `}

  ${minResolution(2)`
    background-image: url('${icBtnArrow2x}');
  `}

  ${minResolution(3)`
    background-image: url('${icBtnArrow3x}');
  `}
`;

const buttonStyleC = css`
  ${buttonStyleA};

  background-color: ${Colors.white1};
  background-image: url('${icBtnArrow2_1x}');
  color: ${Colors.orange1};
  box-shadow: 0 0 0 1px ${Colors.orange1} inset;

  &:active {
    background-color: ${Colors.orange2};
    cursor: pointer;
  }

  &:disabled {
    background-color: ${Colors.white1} !important;
    opacity: 0.5;
  }

  ${CustomMedia.greaterThan('umedium')`
    &:hover {
      background-color: ${Colors.orange2};
      cursor: pointer;
    }
  `}

  ${minResolution(2)`
    background-image: url('${icBtnArrow2_2x}');
  `}

  ${minResolution(3)`
    background-image: url('${icBtnArrow2_3x}');
  `}
`;

const buttonStyleE = css`
  ${FontStyles.text10};

  background-color: ${Colors.white1};
  background-image: url('${icBtnPlus1x}');
  background-size: 18px;
  background-position: calc(100% - 8px) 50%;
  color: ${Colors.black1};
  box-shadow: 0 0 0 1px ${Colors.black1} inset;

  &.opened {
    background-image: url('${icBtnMinus1x}');
  }

  ${CustomMedia.greaterThan('umedium')`
    &:hover {
      background-color: ${Colors.gray4};
    }
  `}

  &:active{
    background-color: ${Colors.gray4};
  }

  &:disabled {
    background-color: ${Colors.white1} !important;
    opacity: 0.5;
  }

  ${CustomMedia.greaterThan('umedium')`
    width: 200px;
    height: 40px;

    &:hover {
      background-color: ${Colors.gray4};
      cursor: pointer;
    }
  `}

  ${CustomMedia.lessThan('medium')`
    width: 160px;
    height: 40px;
  `}

  ${minResolution(2)`
    background-image: url('${icBtnPlus2x}');

    &.opened {
      background-image: url('${icBtnMinus2x}');
    }
  `}

  ${minResolution(3)`
    background-image: url('${icBtnPlus3x}');

    &.opened {
      background-image: url('${icBtnMinus3x}');
    }
  `}
`;

const buttonStyleG = css`
  ${FontStyles.text7};

  background-color: ${Colors.white1};
  background-position: 0 50%;
  color: ${Colors.orange1};

  &:active {
    color: ${Colors.orange3};
    cursor: pointer;
  }

  ${CustomMedia.greaterThan('umedium')`
    &:hover {
      color: ${Colors.orange3};
      cursor: pointer;
    }
  `}

  &:disabled {
    color: ${Colors.orange1} !important;
    opacity: 0.5;
  }

  ${CustomMedia.greaterThan('umedium')`
    padding: 0 0 0 20px;
    background-size: 18px;
  `}

  ${CustomMedia.lessThan('medium')`
    padding: 0 0 0 18px;
    background-size: 16px;
  `}
`;

const buttonStyles = {
  A: buttonStyleA,
  B: css`
    ${buttonStyleA};

    background-image: none !important;
  `,
  C: buttonStyleC,
  D: css`
    ${buttonStyleC};

    background-image: none !important;
  `,
  E: buttonStyleE,
  F: css`
    ${buttonStyleE};

    color: ${Colors.orange1};
    background-image: none !important;

    &:disabled {
      color: ${Colors.orange1} !important;
    }
  `,
  'F-back': css`
    ${buttonStyleE};

    color: ${Colors.orange1};
    background-image: url('${icBtnArrowLeft1x}');
    background-position: 8px 50%;

    ${minResolution(2)`
      background-image: url('${icBtnArrowLeft2x}');
    `}

    ${minResolution(3)`
      background-image: url('${icBtnArrowLeft3x}');
    `}
  `,
  'G-edit': css`
    ${buttonStyleG};

    ${CustomMedia.greaterThan('umedium')`
      background-image: url('${icBtnEditPC1x}');

      ${minResolution(2)`
        background-image: url('${icBtnEditPC2x}');
      `}

      &:active,
      &:hover {
        background-image: url('${icBtnEditPressPC1x}');
        cursor: pointer;

        ${minResolution(2)`
          background-image: url('${icBtnEditPressPC2x}');
        `}
      }
    `}

    ${CustomMedia.lessThan('medium')`
      background-image: url('${icBtnEditSP2x}');

      ${minResolution(3)`
        background-image: url('${icBtnEditSP3x}');
      `}

      &:active,
      &:hover {
        background-image: url('${icBtnEditPressSP2x}');
        cursor: pointer;

        ${minResolution(3)`
          background-image: url('${icBtnEditPressSP3x}');
        `}
      }
    `}
  `,
  'G-delete': css`
    ${buttonStyleG};

    ${CustomMedia.greaterThan('umedium')`
      background-image: url('${icBtnDeletePC1x}');

      ${minResolution(2)`
        background-image: url('${icBtnDeletePC2x}');
      `}

      &:active,
      &:hover {
        background-image: url('${icBtnDeletePressPC1x}');
        cursor: pointer;

        ${minResolution(3)`
          background-image: url('${icBtnDeletePressPC2x}');
        `}
      }
    `}

    ${CustomMedia.lessThan('medium')`
      background-image: url('${icBtnDeleteSP2x}');

      ${minResolution(3)`
        background-image: url('${icBtnDeleteSP3x}');
      `}

      &:active {
        background-image: url('${icBtnDeletePressSP2x}');
        cursor: pointer;

        ${minResolution(3)`
          background-image: url('${icBtnDeletePressSP3x}');
        `}
      }
    `}
  `,
  'G-confirm': css`
    ${buttonStyleG};

    ${CustomMedia.greaterThan('umedium')`
    background-image: url('${icBtnConfirmPC1x}');

    ${minResolution(2)`
      background-image: url('${icBtnConfirmPC2x}');
    `}

    &:active,
    &:hover {
      background-image: url('${icBtnConfirmPressPC1x}');
      cursor: pointer;

      ${minResolution(3)`
        background-image: url('${icBtnConfirmPressPC2x}');
      `}
    }
  `}

    ${CustomMedia.lessThan('medium')`
    background-image: url('${icBtnConfirmSP2x}');

    ${minResolution(3)`
      background-image: url('${icBtnConfirmSP3x}');
    `}

    &:active {
      background-image: url('${icBtnConfirmPressSP2x}');
      cursor: pointer;

      ${minResolution(3)`
        background-image: url('${icBtnConfirmPressSP3x}');
      `}
    }
  `}
  `,
  H: css`
    ${FontStyles.text10};

    background-color: ${Colors.white1};
    color: ${Colors.orange1};
    box-shadow: 0 0 0 1px ${Colors.black1} inset;

    ${CustomMedia.greaterThan('umedium')`
      &:hover {
        background-color: ${Colors.gray4};
      }
    `}

    &:active {
      background-color: ${Colors.gray4};
    }

    &:disabled {
      color: ${Colors.gray1} !important;
      background-color: ${Colors.gray3} !important;
      opacity: 1;
      box-shadow: none;
      cursor: not-allowed;
    }

    ${CustomMedia.greaterThan('umedium')`
      width: 200px;
      height: 40px;

      &:hover {
        background-color: ${Colors.gray4};
        cursor: pointer;
      }
    `}

    ${CustomMedia.lessThan('medium')`
      width: 160px;
      height: 40px;
    `}
  `,
  Close: css`
    position: absolute;
    padding: 0;
    background-color: transparent;
    border: 0;
    outline: none;
    cursor: pointer;

    ${CustomMedia.greaterThan('umedium')`
      top: -36px;
      right: -36px;
      width: 72px;
      height: 72px;
      background-image: url('${icBtnClosePC1x}');
      background-size: 72px;

      ${minResolution(2)`
        background-image: url('${icBtnClosePC2x}');
      `}

      &:hover,
      &:active {
        background-image: url('${icBtnClosePressPC1x}');
        cursor: pointer;

        ${minResolution(2)`
          background-image: url('${icBtnClosePressPC2x}');
        `}
      }
    `}

    ${CustomMedia.lessThan('medium')`
      top: -24px;
      right: -12px;
      width: 48px;
      height: 48px;
      background-image: url('${icBtnCloseSP2x}');
      background-size: 48px;

      ${minResolution(3)`
        background-image: url('${icBtnCloseSP3x}');
      `}

      &:active {
        background-image: url('${icBtnClosePressSP2x}');

        ${minResolution(2)`
          background-image: url('${icBtnClosePressSP3x}');
        `}
      }
    `}
  `
};

export const GEditHoverStyle = css`
  ${buttonStyleG};
  color: ${Colors.orange3};

  ${CustomMedia.greaterThan('umedium')`
    background-image: url('${icBtnEditPressPC1x}');

    ${minResolution(2)`
      background-image: url('${icBtnEditPressPC2x}');
    `}
  `}

  ${CustomMedia.lessThan('medium')`
    background-image: url('${icBtnEditPressSP2x}');

    ${minResolution(3)`
      background-image: url('${icBtnEditPressSP3x}');
    `}
  `}
`;

export const GConfirmHoverStyle = css`
  ${buttonStyleG};
  color: ${Colors.orange3};

  ${CustomMedia.greaterThan('umedium')`
    background-image: url('${icBtnConfirmPressPC1x}');

    ${minResolution(3)`
      background-image: url('${icBtnConfirmPressPC2x}');
    `}
  `}

  ${CustomMedia.lessThan('medium')`
    background-image: url('${icBtnConfirmPressSP2x}');

    ${minResolution(3)`
      background-image: url('${icBtnConfirmPressSP3x}');
    `}
  `}
`;

const Button = styled.button`
  padding: 0;
  border: 0;
  appearance: none;
  outline: none;
  transition: all 0.1s ease;
  cursor: pointer;

  &:disabled {
    background-color: ${Colors.gray3};
    background-image: none !important;
    color: ${Colors.white1} !important;
  }

  ${({ buttonType }) => {
    if (buttonStyles[buttonType] == null) {
      console.error('[Button] buttonTypeの値が不正です。');
    }

    return buttonStyles[buttonType];
  }};
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button/index.js